import React, { FC, PropsWithChildren } from 'react';
import { Animated, ScrollViewProps } from 'react-native';

import { Screen, ScreenProps, SheetScreen } from '@/components/ScreenComponent';
import { ScreenNavBar, ScreenNavBarProps } from '@/components/ScreenNavBar';
import { common } from '@/styles/styles';

type ScrollableScreenProps = PropsWithChildren<{
    screenNavBarProps: ScreenNavBarProps;
    scrollViewProps?: ScrollViewProps;
    unsafe?: boolean;
    footer?: React.ReactNode;
    screenProps?: Omit<ScreenProps, 'children'>;
    sheet?: boolean;
}>;

/**
 * @deprecated Compose Screen, ScreenNavBar, and ScrollView directly instead
 */
export const ScrollableScreen: FC<ScrollableScreenProps> = ({
    screenNavBarProps,
    scrollViewProps,
    footer,
    children,
    screenProps,
    sheet,
}) => {
    const content = (
        <>
            <ScreenNavBar sheet={sheet} {...screenNavBarProps} />
            <Animated.ScrollView
                {...scrollViewProps}
                keyboardShouldPersistTaps="handled"
                style={[common.paddingHorizontal, scrollViewProps?.style && scrollViewProps.style]}
            >
                {children}
            </Animated.ScrollView>
            <>{footer}</>
        </>
    );

    if (sheet) {
        return (
            <SheetScreen edges={screenProps?.edges} style={screenProps?.style}>
                {content}
            </SheetScreen>
        );
    }

    return <Screen {...screenProps}>{content}</Screen>;
};
